import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { cloneDeep } from 'lodash';
import { BokunState } from '../objects/bokunState';
import { BokunAccount, BokunChannel } from '../objects/bokun';

const initialState: BokunState = {
    account: null,
    account_loaded_for: null,
    account_loading: false,
    account_error: null,
    channel_list: [],
    channel_list_loading: false,
    channel_refresh: false,
};

export const bokun = createSlice({
    name: 'bokun',
    initialState,
    reducers: {
        setBokunAccount(state, action: PayloadAction<{ account: BokunAccount | null, client_id: number, error?: string | null }>) {
            state.account = action.payload.account;
            state.account_loaded_for = action.payload.client_id;
            state.account_error = action.payload.error ?? null;
        },
        updateBokunAccountLoading(state, action: PayloadAction<boolean>) {
            state.account_loading = action.payload;
        },
        setBokunChannelList(state, action: PayloadAction<BokunChannel[]>) {
            state.channel_list = action.payload;
        },
        updateBokunChannel(state, action: PayloadAction<BokunChannel>) {
            const channel_list = cloneDeep(state.channel_list);
            const index = channel_list.findIndex(channel => channel.id === action.payload.id);
            if (index === -1) {
                channel_list.push(action.payload);
            } else {
                channel_list[index] = action.payload;
            }
            state.channel_list = channel_list;
        },
        updateBokunChannelListLoading(state, action: PayloadAction<boolean>) {
            state.channel_list_loading = action.payload;
        },
        toggleBokunChannelRefresh(state) {
            state.channel_refresh = !state.channel_refresh;
        },
    },
});

export const {
    setBokunAccount,
    updateBokunAccountLoading,
    setBokunChannelList,
    updateBokunChannel,
    updateBokunChannelListLoading,
    toggleBokunChannelRefresh,
} = bokun.actions;

export default bokun.reducer;
